<template>
    <Dialog v-model:visible="visible_" modal header="Отмена подписки" @hide="close"
        class="border-none"
        :style="{ width: '28rem' }">
        <div class="flex flex-column gap-3">
            <div class="flex flex-column gap-1">
                <span class="text-xs font-medium">ID подписки</span>
                <span class="text-sm">{{ subscriptionId }}</span>
            </div>
            <div class="flex flex-column gap-1">
                <span class="text-xs text-600">Подписка будет отменена.</span>
            </div>
            <div class="flex justify-content-end gap-2 mt-2">
                <Button label="Отменить подписку" size="small" severity="danger" :loading="loading" @click="cancelSubscription" />
                <Button label="Назад" size="small" severity="secondary" @click="close" />
            </div>
        </div>
    </Dialog>
</template>

<script>
import Connect from '@/assets/js/connect.js'
import Helper from '@/assets/js/helper.js'

export default {
    name: 'PersonalSubscriptionCancel',
    props: {
        modelValue: {
            type: Boolean,
            default: false
        },
        subscriptionId: {
            type: [Number, String],
            required: true
        }
    },
    emits: ['update:modelValue', 'canceled'],
    data() {
        return {
            visible_: false,
            loading: false,
        }
    },
    methods: {
        async cancelSubscription() {
            if (!this.subscriptionId) return
            this.loading = true
            try {
                const resp = await this.connect.CancelPersonalSubscription(this.subscriptionId).then(res => res)
                if (resp && resp.result) {
                    const status = resp.data && resp.data.status ? resp.data.status : 'canceled'
                    const message = resp.message || (resp.data && resp.data.message) || 'Подписка отменена'
                    this.$toast.add({ severity: 'success', summary: this.helper.getStatusTitle(status), detail: message, life: 3000 })
                    this.$emit('canceled', { id: this.subscriptionId, status })
                    this.close()
                } else {
                    const message = resp && resp.message ? resp.message : 'Не удалось отменить подписку'
                    this.$toast.add({ severity: 'warn', summary: 'Ошибка', detail: message, life: 2500 })
                }
            } catch (e) {
                this.$toast.add({ severity: 'error', summary: 'Ошибка', detail: 'Ошибка запроса', life: 1500 })
            } finally {
                this.loading = false
            }
        },
        close() {
            this.visible_ = false
            this.$emit('update:modelValue', false)
        }
    },
    watch: {
        modelValue: {
            immediate: true,
            handler(v) {
                this.visible_ = v
            }
        }
    },
    async beforeCreate() {
        this.connect = new Connect()
        this.helper = new Helper()
    }
}
</script>